
declare var dataLayer: any;
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    Questions: () => import("@/components/postulation/Questions.vue"),
  },
})
export default class Postulation extends Vue {
  @Prop(String) modalClass!: any;
  offerId: number = 0;
  offer: any = {};
  active_tab: number = 0;
  final: boolean = false;
  Preguntas: any = [];
  reloadOnClose: boolean = false;
  form: any = {
    checked: [],
  };

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
    (this as any).$root.$on("bv::modal::hide", (bvEvent: any, modalId: any) => {
      if ((this as any).reloadOnClose) {
        (location as any).reload();
      }
    });
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
    if (this.reloadOnClose) (location as any).reload();
  }

  async showModal() {
    const _this: any = this;
    _this.offer = (
      await _this.$root._get(`offer/one/${_this.offerId}`)
    ).data[0];
    if (_this.offer.ask_income) {
      _this.Preguntas = [
        ..._this.offer.nucleus_offer.Preguntas,
        {
          Opciones: [],
          ID: 9999,
          d_pregunta: "Cuál es su sueldo pretendido?",
        },
      ];
    } else {
      _this.Preguntas = _this.offer.nucleus_offer.Preguntas;
    }
    _this.final = !_this.Preguntas.length;
    _this.$refs["postulate-modal"].show();

    if (_this.final) {
      //verifica que exista el tipo y numero de documento antes de guardar
      if (this.$store.state.user.dni_type && this.$store.state.user.dni) {
        (this as any).saveOffer();
      }
    }
  }

  hideModal() {
    (this as any).$refs["postulate-modal"].hide();
    this.$router.push("/ofertas");
    window.scrollTo(0, 0);
  }

  async nextStep() {
    if (!this.Preguntas[this.active_tab].answer) return;
    this.active_tab++;
    if (this.active_tab == this.Preguntas.length) {
      //verifica que exista el tipo y numero de documento antes de guardar
      if (this.$store.state.user.dni_type && this.$store.state.user.dni) {
        (this as any).saveOffer();
      }
    }
  }

  async saveOffer() {
    this.final = true;
    let elements: any = document.getElementsByClassName("modal-title");
    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
    (this as any).reloadOnClose = true;
    let n_remuneracion = 0;
    if (this.offer.ask_income) n_remuneracion = this.Preguntas.pop().answer;

    await (this as any).$root._post(`useroffer`, {
      status: this.$store.state.user.active ? 1 : 0,
      offerId: (this as any).offer.id,
      postulate: 1,
      n_remuneracion,
      favorite: (this as any).offer.favorite ? (this as any).offer.favorite : 0,
      answers: this.Preguntas,
    });

    dataLayer.push({
      event: "VirtualPageview",
      virtualPageURL: "/postulacion-exitosa",
      virtualPageTitle: "Postulación Exitosa",
    });
  }

  backStep() {
    this.active_tab - 1;
  }

  goTo() {
    this.$router.push("/perfil");
    window.scrollTo(0, 0);
  }
}
